import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-download-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-download-modal.component.html',
  styleUrl: './app-download-modal.component.scss'
})
export class AppDownloadModalComponent {
  @Output() close = new EventEmitter<void>();

  readonly iosUrl = environment.appStoreIosUrl;
  readonly androidUrl = environment.appStoreAndroidUrl;

  @HostListener('document:keydown.escape')
  onEscape() {
    this.close.emit();
  }

  onOverlayClick() {
    this.close.emit();
  }
}
